import { render, staticRenderFns } from "./MailSetting.vue?vue&type=template&id=51d996b3"
import script from "./MailSetting.vue?vue&type=script&lang=ts"
export * from "./MailSetting.vue?vue&type=script&lang=ts"
import style0 from "./MailSetting.vue?vue&type=style&index=0&id=51d996b3&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports